// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Ptje","buttons":"Footer_buttons__13yIh"};